import { WishlistElementHeadless } from 'https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.29.2/wishlist-element-headless.js'

class WishlistButtonHeadless extends WishlistElementHeadless {
  getStateConfig () {
    this.isFirstUpdate = true

    return {
      productInfo: true
    }
  }

  getEventConfig () {
    return {
      click: this.handleClick
    }
  }

  handleClick () {
    if (this.productInfo.inWishlist) {
      return this.app.removeWishlistItem(this.productInfo)
    } else {
      return this.app.addWishlistItem(this.productInfo)
    }
  }

  updated () {
    this.host.classList.toggle('wk-selected', this.productInfo.inWishlist)

    const textElement = this.host.querySelector('.wk-text')

    if (textElement) {
      textElement.innerText = this.getText()
    }

    if (this.isFirstUpdate) {
      this.isFirstUpdate = false
      return
    }

    this.toolTipEl = this.host.parentNode.querySelector('.wk-tooltip')
    if (!this.toolTipEl) return

    if (this.productInfo.inWishlist) {
      this.toolTipEl.classList.add('show')

      setTimeout(() => this.toolTipEl.classList.remove('show'), 3000)
    } else {
      this.toolTipEl.classList.remove('show')
    }
  }

  getText () {
    if (this.productInfo.inWishlist) {
      return 'Remove from Wishlist'
    }
    return 'Add to Wishlist'
  }
};

window.headlessElements.define('wishlist-button-headless', WishlistButtonHeadless)
